import styled, { css } from "styled-components";
import { theme } from "../styled/theme";
import { Container } from "../styled/BaseComponents";

export const MarketplaceSection = styled.section`
  margin-top: 2rem;
`;

export const InnerContainer = styled(Container)`
  max-width: 1240px;
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export const HighlightCard = styled.div`
  margin-top: 1.5rem;
  border-radius: 1.25rem;
  border: 1px solid rgba(251, 191, 36, 0.4);
  padding: 1.25rem;
  background: linear-gradient(
    90deg,
    rgba(251, 191, 36, 0.12),
    transparent,
    rgba(251, 191, 36, 0.06)
  );
`;

export const HighlightHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
`;

export const HighlightLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fbbf24;
`;

export const HighlightPill = styled.span`
  border-radius: 999px;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: #fbbf24;
  background: rgba(251, 191, 36, 0.18);
`;

export const HighlightGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 0.75rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const CardBase = styled.div`
  border-radius: 1rem;
  border: 1px solid ${theme.colors.border || "#1f2937"};
  background: rgba(15, 23, 42, 0.9);
  padding: 1rem;
`;

export const ResellerSection = styled.div`
  margin-top: 2.5rem;
`;

export const ResellerTitle = styled.div`
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${theme.colors.muted || "#94a3b8"};
`;

export const ResellerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 0.75rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const ResellerCardRoot = styled(CardBase)`
  padding: 1.25rem;
  border-radius: 1.5rem;
  border-color: rgba(15, 23, 42, 1);
  background:
    radial-gradient(120% 200% at 0% 0%, rgba(251, 191, 36, 0.14), transparent 55%),
    #020617;

  ${(props) =>
    props.$highlight &&
    css`
      border-color: rgba(251, 191, 36, 0.45);
      background: linear-gradient(
        135deg,
        rgba(251, 191, 36, 0.26),
        rgba(15, 23, 42, 0.96)
      );
      box-shadow: 0 0 0 1px rgba(251, 191, 36, 0.15),
        0 18px 45px rgba(15, 23, 42, 0.9);
    `}
`;

// "More Stores" summary card (7th card)
export const MoreStoresCard = styled(ResellerCardRoot)`
  border-style: dashed;
  border-radius: 1.5rem;
  background: #020617;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const MoreStoresInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
`;

export const MoreStoresNumber = styled.div`
  font-size: 1.75rem;
  font-weight: 700;
`;

export const MoreStoresLabel = styled.div`
  font-size: 0.9rem;
  color: ${theme.colors.muted || "#94a3b8"};
`;

export const MoreStoresLink = styled.button`
  margin-top: 0.25rem;
  border: none;
  background: transparent;
  font-size: 0.9rem;
  font-weight: 600;
  color: #38bdf8; /* sky-400 */
  cursor: pointer;
  text-decoration: underline;
`;

// "More Tenders" summary card for auction highlight
export const MoreTendersCard = styled(CardBase)`
  border-radius: 1.25rem;
  border-style: dashed;
  border-color: rgba(251, 191, 36, 0.4);
  background: rgba(251, 191, 36, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const MoreTendersInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
`;

export const MoreTendersNumber = styled.div`
  font-size: 1.75rem;
  font-weight: 700;
  color: #fbbf24;
`;

export const MoreTendersLabel = styled.div`
  font-size: 0.9rem;
  color: ${theme.colors.muted || "#94a3b8"};
`;

export const MoreTendersLink = styled.button`
  margin-top: 0.25rem;
  border: none;
  background: transparent;
  font-size: 0.9rem;
  font-weight: 600;
  color: #fbbf24;
  cursor: pointer;
  text-decoration: underline;
`;

export const ResellerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`;

export const ResellerLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const ResellerAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 0.75rem;
  background: linear-gradient(135deg, #1f2937, #111827);
  font-size: 0.75rem;
  font-weight: 700;
`;

export const ResellerName = styled.div`
  font-weight: 600;
`;

export const ResellerDescription = styled.div`
  font-size: 0.75rem;
  color: ${theme.colors.muted || "#94a3b8"};
`;

export const ResellerBadge = styled.span`
  border-radius: 999px;
  padding: 0.25rem 0.75rem;
  font-size: 0.7rem;
  font-weight: 700;
  color: #fbbf24;
  background: rgba(251, 191, 36, 0.18);
`;

export const ResellerStats = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  text-align: center;
  font-size: 0.75rem;
`;

export const ResellerStatBox = styled.div`
  border-radius: 0.5rem;
  // border: 1px solid ${theme.colors.border || "#1f2937"};
  // background: #020617;
  padding: 0.5rem;
`;

export const StatValue = styled.div`
  font-size: 0.9rem;
  font-weight: 700;
`;

export const StatLabel = styled.div`
  color: ${theme.colors.muted || "#94a3b8"};
`;

export const PrimaryButton = styled.button`
  width: 100%;
  margin-top: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #1f2937;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #f9fafb;
  background: #020617;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;

  &:hover {
    background: #0f172a;
    transform: translateY(-1px);
  }
`;

export const SidebarOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  z-index: 120;
`;

export const SidebarPanel = styled.aside`
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  width: 100%;
  max-width: 26rem;
  overflow-y: auto;
  background: #020617;
  border-left: 1px solid #1f2937;
  box-shadow: -12px 0 40px rgba(15, 23, 42, 0.9);
  padding: 1.5rem;
  z-index: 130;
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
`;

export const SidebarTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
`;

export const SidebarClose = styled.button`
  border: none;
  background: transparent;
  color: ${theme.colors.muted || "#94a3b8"};
  cursor: pointer;
  font-size: 1.1rem;
`;

export const SidebarList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

// Sidebar store card (simpler, flat style)
export const SidebarStoreCard = styled(CardBase)`
  border-radius: 1.25rem;
  border-color: #1C293D;
  // background: #020617;
  padding: 1rem 1.25rem;
  box-shadow: none;
    background: #0A1023;

`;

export const ProductsSection = styled.div`
  margin: 2rem 0 1.5rem;
`;

export const ProductsTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${theme.colors.muted || "#94a3b8"};
  margin-bottom: 0.5rem;
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 0.75rem;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const ProductCardRoot = styled(CardBase)`
  padding: 0.75rem;
  border-radius: 1.25rem;
`;

